import { MdlDialogReference } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ConfirmDialogRequest, SHIPMENT_CONFIRM_TOKEN } from '../confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'delete-warning-dialog',
    template: require('./delete-warning-dialog.component.html'),
    styles: [require('./delete-warning-dialog.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DeleteDialogComponent {
    public data: ConfirmDialogRequest;
    public reverseButtons?: boolean;

    constructor(
        private dialog: MdlDialogReference,
        @Inject(SHIPMENT_CONFIRM_TOKEN) private readonly request: ConfirmDialogRequest) {
        if (request.gridDetails) {
            request.gridDetails.header = request.gridDetails.header.filter(t => !t.actions);
        }
        this.data = request;
    }

    public onActionClick(isYesButtonClicked: boolean) {

        return this.dialog.hide({
            isYesButtonClicked
        });
    }
}